import * as u from './utils';
import noScroll from 'no-scroll';

export default () => {
    const menus = document.querySelectorAll('.page-menu');
    const hoverBlock = document.querySelectorAll('.mega-menu__hoverer');
    let activeMenu;
    const links = document.querySelectorAll('.page-menu__link');
    const children = document.querySelectorAll('.page-menu__children');
    let activeChildMenu;

    if (menus.length < 1) {
        return;
    }

    // Setup sub menu controls

    const closeChildMenu = () => {
        const activeTrigger = document.querySelector('.page-menu__link.is-active');
        const childActiveMenu = document.querySelector('.page-menu__children.is-active');

        if (!activeTrigger) {
            return;
        }

        // Remove active state
        u.removeClass(activeTrigger, 'is-active');
        u.removeClass(childActiveMenu, 'is-active');

        // Stop recording the menu as active
        activeChildMenu = false;
    };

    const openChildMenu = (el) => {
        const trigger = el.querySelector('.page-menu__link');
        const childMenu = el.querySelector('.page-menu__children');

        // add active state
        u.addClass(trigger, 'is-active');
        u.addClass(childMenu, 'is-active');

        // Record the active menu
        activeChildMenu = trigger.parentNode;
    };

    const handleChildrenClick = (e) => {
        if (activeChildMenu) {
            if (e.currentTarget.parentNode === activeChildMenu) {
                closeChildMenu();
                return;
            }
            closeChildMenu();
        }

        openChildMenu(e.currentTarget.parentNode);
    };

    for (const el of children) {
        el.parentNode.querySelector('.page-menu__link').addEventListener('click', handleChildrenClick);
    }

    // Setup main menu click event for showing and hiding the menu
    const closeMenu = () => {
        const trigger = document.querySelector('.mega-menu__link.is-active');
        const menu = document.querySelector('.page-menu.is-active');

        // Only remove if we have them (Will not have them is user is on mobile)
        if (trigger) {
            u.removeClass(trigger, 'is-active');
            u.removeClass(menu, 'is-active');
        }

        // Close any open child menu
        closeChildMenu();

        // Stop tracking active menu
        activeMenu = false;

        // Reactivate scrolling
        noScroll.off();

        // Remove body class
        u.removeClass(document.body, 'menu-open');
    };

    const openMenu = (el) => {
        const trigger = el.querySelector('.mega-menu__link');
        const menu = el.querySelector('.page-menu');

        u.addClass(trigger, 'is-active');
        u.addClass(menu, 'is-active');

        // Track active menu
        activeMenu = menu;

        // Add body class
        u.addClass(document.body, 'menu-open');

        // Disable scrolling
        noScroll.on();
    };

    const handleMenuClick = (e) => {
        e.preventDefault();

        const menu = e.currentTarget.parentNode.querySelector('.page-menu');

        if (activeMenu) {
            if (menu === activeMenu) {
                closeMenu();
                return;
            }
            closeMenu();
        }

        openMenu(e.currentTarget.parentNode);
    };

    for (const el of menus) {
        el.parentNode.querySelector('.mega-menu__link').addEventListener('click', handleMenuClick);
    }

    // Handle opening and closing on hover
    const handleMenuMouseEnter = (e) => {
        e.preventDefault();
        openMenu(e.currentTarget.parentNode);
    };

    const handleHoverResize = (query) => {
        if (query.matches) {
            for (const el of hoverBlock) {
                el.parentNode.removeEventListener('mouseenter', handleMenuMouseEnter);
                el.parentNode.removeEventListener('mouseleave', closeMenu);
            }
        } else {
            for (const el of hoverBlock) {
                el.parentNode.addEventListener('mouseenter', handleMenuMouseEnter);
                el.parentNode.addEventListener('mouseleave', closeMenu);
            }
        }
    };

    const query = window.matchMedia('(max-width: 1024px)');
    handleHoverResize(query);
    query.addListener(handleHoverResize);

    // Register close button
    document.querySelector('.header__close').addEventListener('click', closeMenu);

    // Setup mobile menu controls
    const mobileMenuToggle = document.querySelectorAll('.header__hamburger, .mega-menu__close');

    const handleMobileMenuToggle = () => {
        if (u.hasClass(document.body, 'mobile-menu-open')) {
            closeMenu();
            noScroll.off();
        } else {
            noScroll.on();
        }
        u.toggleClass(document.body, 'mobile-menu-open');
    };

    for (const el of mobileMenuToggle) {
        el.addEventListener('click', handleMobileMenuToggle);
    }

    const handleMobileBackClick = () => {
        if (activeChildMenu) {
            closeChildMenu();
        } else {
            closeMenu();
            noScroll.on(); // force noscroll back on
        }
    };

    const mobileBack = document.querySelectorAll('.page-menu__back');
    for (const el of mobileBack) {
        el.addEventListener('click', handleMobileBackClick);
    }
};
